export default __webpack_public_path__ + "static/media/rovers.fe511cb9.png";